jQuery(document).ready(function($) {
  var isAdmin = object_name.isAdmin
  if (!isAdmin) {
    $('.harron-tester-only').hide()
    $('.harron-tester-only')
      .parent()
      .hide()
    var menuBefore = $('.harron-tester-only')
      .parent()
      .prev()
      .addClass('menu-after-hidden')
  }
  $('.open__reserve[data-open]').on('click', function() {
    // First, reload gravity form to default
    var gwrf = window.gwrf_4
    if (typeof gwrf != 'undefined') {
      gwrf.reloadForm()
    }

    var jsonUrl = object_name.jsonBase
    var targetModal = $('#' + $(this).data('open'))
    var plotId = $(this).data('plot')
    var developmentName = $(this).data('development-name')
    var plotArticle = $('#plot-' + plotId)
    console.log(plotArticle)

    var houseType = plotArticle.find('.text__plot--housetype').text()
    var plotNumber = plotArticle.find('.text__plot--plot').text()
    var plotBedrooms = plotArticle.find('.text__plot--bedrooms').text()
    var plotPrice = plotArticle.find('.text__plot--price').text()
    $('#product-development').text(developmentName)
    $('#product-housetype').text(houseType)
    $('#product-sku').text(plotNumber)
    $('#product-price').text(plotPrice)
    $('#product-bedrooms').text(plotBedrooms)
    $('#product-image').html('')
    plotArticle
      .find('.plot__image-container img')
      .clone()
      .appendTo('#product-image')
    $('#product-loader').removeClass('loading')
    $('input[name ="input_8"]').val(plotId)
    // if (data.acf.is_plot_on_offer && data.acf.plot_offer_price) {
    //   $('#product-price').text(data.acf.plot_offer_price)
    // } else {
    //   $('#product-price').text(data.acf.plot_price)
    // }

    // $('#product-loader').addClass('loading')
    // $.getJSON(jsonUrl + 'wp/v2/harron_plots/' + plotId, function(data) {
    //   console.log('success')
    // })
    //   .done(function(data) {
    //     $('#product-loader').removeClass('loading')
    //     console.log(data)
    //     $('#product-development').text(data.acf.development.post_title)
    //     $('#product-housetype').text(data.acf.housetype.post_title)
    //     $('#product-sku').text(data.acf.plot_number)
    //     if (data.acf.is_plot_on_offer && data.acf.plot_offer_price) {
    //       $('#product-price').text(data.acf.plot_offer_price)
    //     } else {
    //       $('#product-price').text(data.acf.plot_price)
    //     }
    //     $('#product-bedrooms').text(data.acf.housetype)
    //   })
    //   .fail(function() {
    //     console.log('failed')
    //   })
    //     .error(function() {
    //       console.log('error')
    //     })
    //   .always(function() {
    //     console.log('always always')
    //   })
  })
})
